import React from "react";
import OfferPage from "../components/OfferPage";

const OfferAutomation = () => (
  <OfferPage
    ns="offerAutomation"
    page="automation"
    path="/offers/automation"
    order={["whatItIs", "forWho", "gets", "after", "faq"]}
  />
);

export default OfferAutomation;
